import React from "react";
import header from "./header.css";
// import img from "../logo/logo.png";

export default function Header(){
    return(
        <div className="head">
            <h1>inDecrease</h1>
        </div>
        
    );
    
}